/**
 * EmployeeRequest model translations
 *
 * Translation keys follow the pattern: models.employee-request.{category}.{key}
 * Categories: fields, tabs, blocks, badges, filters, options
 */
export default {
  en: {
    singular: "Request",
    plural: "Requests",

    tabs: {
      details: "Details",
      approval: "Approval",
      request_data: "Request Data",
    },

    blocks: {
      basic: "Basic Info",
      dates: "Dates",
      approval_info: "Approval Information",
      json_data: "Request Data",
    },

    fields: {
      type: "Type",
      status: "Status",
      notes: "Notes",
      start_date: "Start Date",
      end_date: "End Date",
      rejection_reason: "Rejection Reason",
      requested_date: "Request Date",
      requested_by_user_id: "Employee",
      display_title: "Title",
      approved_by_user_id: "Approved By",
      approved_at: "Approved At",
      rejected_by_user_id: "Rejected By",
      rejected_at: "Rejected At",
      request_data: "Request Data",
      created_at: "Created At",
      updated_at: "Updated At",
    },

    badges: {
      draft: "Draft",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      cancelled: "Cancelled",
      // Uppercase variants (enum values)
      DRAFT: "Draft",
      PENDING: "Pending",
      APPROVED: "Approved",
      REJECTED: "Rejected",
      CANCELLED: "Cancelled",
    },

    filters: {
      type: "Type",
      status: "Status",
      requested_by_user_id: "Employee",
      start_date: "Start Date",
      end_date: "End Date",
    },

    options: {
      type: {
        vacation: "Vacation Request",
        manager_help: "Manager Assistance",
        equipment: "Equipment Request",
      },
      status: {
        DRAFT: "Draft",
        PENDING: "Pending",
        APPROVED: "Approved",
        REJECTED: "Rejected",
        CANCELLED: "Cancelled",
      },
    },
  },

  fr: {
    singular: "Demande",
    plural: "Demandes",

    tabs: {
      details: "Détails",
      approval: "Approbation",
      request_data: "Données de la demande",
    },

    blocks: {
      basic: "Informations de base",
      dates: "Dates",
      approval_info: "Informations d'approbation",
      json_data: "Données de la demande",
    },

    fields: {
      type: "Type",
      status: "Statut",
      notes: "Notes",
      start_date: "Date de début",
      end_date: "Date de fin",
      rejection_reason: "Motif de refus",
      requested_date: "Date de la demande",
      requested_by_user_id: "Employé",
      display_title: "Titre",
      approved_by_user_id: "Approuvé par",
      approved_at: "Approuvé le",
      rejected_by_user_id: "Refusé par",
      rejected_at: "Refusé le",
      request_data: "Données de la demande",
      created_at: "Créé le",
      updated_at: "Modifié le",
    },

    badges: {
      draft: "Brouillon",
      pending: "En attente",
      approved: "Approuvé",
      rejected: "Refusé",
      cancelled: "Annulé",
      // Uppercase variants (enum values)
      DRAFT: "Brouillon",
      PENDING: "En attente",
      APPROVED: "Approuvé",
      REJECTED: "Refusé",
      CANCELLED: "Annulé",
    },

    filters: {
      type: "Type",
      status: "Statut",
      requested_by_user_id: "Employé",
      start_date: "Date de début",
      end_date: "Date de fin",
    },

    options: {
      type: {
        vacation: "Demande de congé/vacances",
        manager_help: "Aide du gestionnaire",
        equipment: "Demande d'équipement",
      },
      status: {
        DRAFT: "Brouillon",
        PENDING: "En attente",
        APPROVED: "Approuvé",
        REJECTED: "Refusé",
        CANCELLED: "Annulé",
      },
    },
  },
};
